import React from 'react';
import { Briefcase, Calendar, MapPin, ArrowRight } from 'lucide-react';

const opportunities = [
  {
    id: 1,
    title: 'Summer Research Internship',
    organization: 'Dhaka University',
    location: 'Dhaka',
    type: 'Internship',
    date: 'June 2024',
    description: 'Join the biology department for a 3-month research internship focusing on environmental science.',
  },
  {
    id: 2,
    title: 'Global Student Leadership Summit',
    organization: 'Youth For Future',
    location: 'Online',
    type: 'Event',
    date: 'July 15, 2024',
    description: 'A virtual summit connecting student leaders from around the world. Keynote speakers from top tech companies.',
  },
  {
    id: 3,
    title: 'Tech Innovation Hackathon',
    organization: 'BUET',
    location: 'Dhaka',
    type: 'Competition',
    date: 'August 5-7, 2024',
    description: 'Build the next big thing in ed-tech. Prizes worth 100,000 BDT.',
  },
  {
    id: 4,
    title: 'Marketing Associate Trainee',
    organization: 'Grameenphone',
    location: 'Dhaka',
    type: 'Job',
    date: 'Apply by May 30',
    description: 'Start your career with the leading telecommunications company in Bangladesh.',
  },
];

const Opportunities = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Latest Opportunities</h1>
          <p className="mt-4 text-xl text-gray-500">
            Curated internships, scholarships, and events for ambitious students.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          {opportunities.map((opp) => (
            <div key={opp.id} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow">
              <div className="px-4 py-5 sm:p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                    opp.type === 'Internship' ? 'bg-green-100 text-green-800' :
                    opp.type === 'Event' ? 'bg-purple-100 text-purple-800' :
                    opp.type === 'Competition' ? 'bg-orange-100 text-orange-800' :
                    'bg-red-100 text-red-800'
                  }`}>
                    {opp.type}
                  </span>
                  <span className="text-sm text-gray-500 flex items-center">
                    <Calendar className="w-4 h-4 mr-1" />
                    {opp.date}
                  </span>
                </div>
                <h3 className="text-lg font-medium text-gray-900">{opp.title}</h3>
                <p className="text-sm text-red-600 mb-2">{opp.organization}</p>
                <p className="text-gray-500 mb-4">{opp.description}</p>
                <div className="flex items-center justify-between mt-4 border-t pt-4">
                  <div className="flex items-center text-sm text-gray-500">
                    <MapPin className="w-4 h-4 mr-1" />
                    {opp.location}
                  </div>
                  <button className="inline-flex items-center text-sm font-medium text-red-600 hover:text-red-500">
                    View Details <ArrowRight className="ml-1 w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Opportunities;
